__turbopack_context__.v({
  "contactus": "Header-module-scss-module__-jtfja__contactus",
  "emailLabel": "Header-module-scss-module__-jtfja__emailLabel",
  "header": "Header-module-scss-module__-jtfja__header",
  "labelFonts": "Header-module-scss-module__-jtfja__labelFonts",
  "navstyle": "Header-module-scss-module__-jtfja__navstyle",
  "navstyleDropdown": "Header-module-scss-module__-jtfja__navstyleDropdown",
  "register": "Header-module-scss-module__-jtfja__register",
  "userLabel": "Header-module-scss-module__-jtfja__userLabel",
});
